<div #container class="footerBar btn-toolbar bg-light fixed-bottom px-4 py-1 border-gray border-top" role="toolbar" aria-label="Toolbar with button groups">
	<ng-content></ng-content>
</div>
